/**
=========================================================
* Material Dashboard 3 PRO React - v2.3.0
=========================================================
*/

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import SbiHeader from "../../components/SbiHeader";
import { useMaterialUIController } from "context";
import { SBI_DARK, SBI_LIGHT } from "assets/theme/base/colors";
import { useBranding, FRESENIUS } from "contextBranding";

// SBI Learning + Program components
import ContinueBootcampCard from "./components/ContinueBootcampCard";
import QuattroMetricsTimeline from "./components/QuattroMetricsTimeline";
import BootcampPathwayTimeline from "./components/BootcampPathwayTimeline";
import UpcomingEventsCard from "./components/UpcomingEventsCard";
import SBICoreCard from "./components/SBICoreCard";
import ProgramDashboardsCard from "./components/ProgramDashboardsCard";
import MediaCommunityCard from "./components/MediaCommunityCard";
import GlobalSocietyCard from "./components/GlobalSocietyCard";

// Context
import { useAuthContext } from "contextAuth";

// Mock data
import {
  currentBootcamp,
  bootcampPathway,
  upcomingEvents,
  sbiCoreRecommendations,
  programDashboards,
  sbiFacesVideos,
  vciMediaCategories,
  globalSociety,
} from "./utils/mockData";

function ELearning() {
  const { userInfo } = useAuthContext();
  const [controller] = useMaterialUIController();
  const { sbiDashboardTheme } = controller;
  const { isFreseniusBranding } = useBranding();
  const isLight = sbiDashboardTheme === "light";
  const theme = isLight ? SBI_LIGHT : SBI_DARK;
  const freseniusTheme = isLight ? FRESENIUS.themeLight : FRESENIUS.themeDark;
  const contentBg = isFreseniusBranding ? freseniusTheme.bgMain : "#0a1628";
  const contentColor = isFreseniusBranding ? freseniusTheme.textPrimary : theme.textPrimary;

  // Get user's name from environment variables or userInfo
  const getUserName = () => {
    const firstName =
      process.env.REACT_APP_DEMO_FIRST_NAME ||
      userInfo?.first_name ||
      "";
    const lastName =
      process.env.REACT_APP_DEMO_LAST_NAME ||
      userInfo?.last_name ||
      "";
    return `${firstName} ${lastName}`.trim() || "User";
  };

  const userName = getUserName();
  const firstName =
    process.env.REACT_APP_DEMO_FIRST_NAME ||
    userInfo?.first_name ||
    "";

  return (
    <DashboardLayout>
      <SbiHeader />
      <MDBox
        pt={3}
        pb={3}
        px={{ xs: 2, md: 3 }}
        sx={{
          backgroundColor: contentBg,
          color: contentColor,
          minHeight: "calc(100vh - 72px)",
          display: "flex",
          flexDirection: "column",
          "& .MuiTypography-root": {
            color: contentColor,
          },
        }}
      >
        {/* Main Content Area */}
        <MDBox py={2}>
          <Grid container spacing={3}>
            {/* TOP ROW */}
            {/* Hero: Continue Bootcamp */}
            <Grid item xs={12} lg={8}>
              <ContinueBootcampCard bootcamp={currentBootcamp} isFreseniusBranding={isFreseniusBranding} />
            </Grid>
            {/* Right widget: Quattro Metrics Timeline */}
            <Grid item xs={12} lg={4}>
              <QuattroMetricsTimeline isFreseniusBranding={isFreseniusBranding} />
            </Grid>

            {/* SECOND ROW */}
            {/* Upcoming events - Full width */}
            <Grid item xs={12}>
              <UpcomingEventsCard events={upcomingEvents} isFreseniusBranding={isFreseniusBranding} />
            </Grid>

            {/* THIRD ROW 
            <Grid item xs={12} md={8}>
              <SBICoreCard recommendations={sbiCoreRecommendations} />
            </Grid>
            <Grid item xs={12} md={4}>
              <ProgramDashboardsCard dashboards={programDashboards} />
            </Grid>
            <Grid item xs={12} md={8}>
              <MediaCommunityCard videos={sbiFacesVideos} categories={vciMediaCategories} />
            </Grid>
            <Grid item xs={12} md={4}>
              <GlobalSocietyCard globalSociety={globalSociety} />
            </Grid> */}
          </Grid>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default ELearning;
